/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { fetchDeals } from './actions';

const initialState = {
  deals: [],
  activeFilters: {},
  error: null,
  loading: false,
  searchQuery: '',
  singleDeal: null,
  singleDealError: null,
  singleDealLoading: false,
  sortBy: 'update-date',
  sortOrder: 'desc',
  count: 0,
  page: 1,
  pageSize: 50,
  currentRequestId: undefined,
} as DealsState;

const dealsSlice = createSlice({
  name: 'deals',
  initialState,
  reducers: {
    setActiveFilters(state, action) {
      state.activeFilters = action.payload;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
    setSortBy(state, action) {
      state.sortBy = action.payload;
    },
    setSortOrder(state, action) {
      state.sortOrder = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Without this guard a slower earlier response lands last and wins.
    builder.addCase(fetchDeals.pending, (state, { meta }) => {
      state.loading = true;
      state.currentRequestId = meta.requestId;
    });
    builder.addCase(fetchDeals.fulfilled, (state, { payload, meta }) => {
      if (state.currentRequestId !== meta.requestId) {
        return;
      }
      state.deals = payload.results;
      state.count = payload.count;
      state.error = false;
      state.loading = false;
    });
    builder.addCase(fetchDeals.rejected, (state, { payload, meta }) => {
      if (state.currentRequestId !== meta.requestId) {
        return;
      }
      state.error = payload;
      state.loading = false;
    });
  },
});

export const {
  setActiveFilters,
  setSearchQuery,
  setSortBy,
  setSortOrder,
  setPage,
  setPageSize,
} = dealsSlice.actions;

export default dealsSlice.reducer;
